module.exports = __webpack_public_path__ + "img/panteras.78749f0e.png";